import { render, staticRenderFns } from "./UserDetailTeleconsulto.vue?vue&type=template&id=3f31f870&"
import script from "./UserDetailTeleconsulto.vue?vue&type=script&lang=js&"
export * from "./UserDetailTeleconsulto.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailTeleconsulto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports